import { Sidebar as SidebarContent } from '@/components/Sidebar/Sidebar'

export function Sidebar() {
  return <SidebarContent />
}
